<script setup lang="ts">
import Logo from '@/js/components/Logo.vue'
</script>

<template>
    <footer class="footer">
        <div class="px-10 py-4 text-center text-white">
            <p class="text-sm">Pure Energy srl - P. IVA e CF 02012090490 - REA LI-224161 - Cap. Soc. 10.000 €</p>
        </div>
    </footer>
</template>
